import { useEffect } from 'react';
import { startCallTone } from '../utils/callTones';

export default function useRingtone(call) {
  useEffect(() => {
    if (call?.status !== 'ringing') return undefined;
    const incoming = call.direction === 'incoming';
    const stop = startCallTone(incoming ? 'incoming' : 'ringback');
    let vibrationTimer;
    if (incoming && navigator.vibrate) {
      const vibrate = () => { try { navigator.vibrate([250, 150, 250]); } catch { /* unsupported */ } };
      vibrate();
      vibrationTimer = setInterval(vibrate, 3000);
    }
    return () => {
      stop();
      clearInterval(vibrationTimer);
      if (incoming && navigator.vibrate) { try { navigator.vibrate(0); } catch { /* unsupported */ } }
    };
  }, [call?.id, call?.status, call?.direction]);
}
